import {RolesAccount} from '@/app/auth';

export const CTokenDecoded = {
  CUSTOM_USER_UUID: 'custom:user_uuid',
  CUSTOM_ROLES: 'custom:roles',
};

export interface ITokenDecodedUser {
  [key: string]: any;
  user_uuid: string;
  role: (typeof RolesAccount)[keyof typeof RolesAccount];
}
